import React, { useEffect } from 'react';
import { Card, Form, Input, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@/shared/components/PageTitle';
import { useAuth } from '@/shared/lib/auth-context';
import { useSettings } from '@/shared/lib/settings-context';

const { Title } = Typography;

const { Option } = Select;


export const SettingsPage: React.FC = () => {
  const [form] = Form.useForm();
  const { user } = useAuth();
  const { t } = useTranslation();
  const { settings, updateSetting, isLoading } = useSettings();

  // Update form values when settings change
  useEffect(() => {
    if (!isLoading) {
      form.setFieldsValue({ language: settings.language });
    }
  }, [settings.language, isLoading, form]);

  // Auto-save handler for language changes
  const handleLanguageChange = (value: string) => {
    updateSetting('language', value);
  };

  return (
    <div>
      <PageTitle 
        title={t('settings.title')} 
        subtitle={t('settings.subtitle')} 
      />
      
      <Card>
        <Form
          form={form}
          layout="vertical"
          style={{ maxWidth: 600 }}
        >
          {/* User Information Section */}
          <div>
            <Title level={4}>{t('settings.userInfo.title')}</Title>
            <Form.Item label={t('settings.userInfo.name')}>
              <Input value={user?.name || ''} disabled />
            </Form.Item>
            <Form.Item label={t('settings.userInfo.email')}>
              <Input value={user?.email || ''} disabled />
            </Form.Item>
          </div>

          {/* Language Selection */}
          <div style={{ marginTop: 32 }}>
            <Title level={4}>{t('settings.appearance.language')}</Title>
            <Form.Item 
              name="language" 
              label={t('settings.languageSelection')}
            >
              <Select 
                value={settings.language}
                onChange={handleLanguageChange}
                style={{ width: 200 }}
              >
                <Option value="en">{t('settings.languages.en')}</Option>
                <Option value="sv">{t('settings.languages.sv')}</Option>
              </Select>
            </Form.Item>
          </div>
        </Form>
      </Card>
    </div>
  );
};